import { render, staticRenderFns } from "./test-advanced-table.vue?vue&type=template&id=bd4b6e8e&lang=html&"
import script from "./test-advanced-table.vue?vue&type=script&lang=js&"
export * from "./test-advanced-table.vue?vue&type=script&lang=js&"
import style0 from "./test-advanced-table.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports